import React from 'react';
//components
import PopUpS from './popupsmall';
//Material-UI
import { Button } from '@material-ui/core';
//Icons
import { Trash } from 'tabler-icons-react';
//Context
import { useProductos } from './ProductosContext';

export default function DeleteProduct() {
    const { delProd, actions, setBorrar } = useProductos();
    return (
        <PopUpS
            colorButton="default"
            buttonClass=""
            textButton={
                <span className="productos-btn-content">
                    <Trash size={16} strokeWidth={1.75} /> Borrar
                </span>
            }
            popupSeconButton="Cancelar"
            isContained="text"
            isActive={actions}
            popupBody={
                <div className="popup-confirm-body">
                    <div className="popup-confirm-icon">
                        <Trash size={128} color="#7D7F90" />
                    </div>
                    <p className="popup-confirm-message">
                        ¿Está seguro que desea eliminar este producto?
                    </p>
                </div>
            }
            popupPrimAction={
                <Button
                    color="primary"
                    variant="contained"
                    className="btn-guardar"
                    onClick={() => { delProd(); setBorrar(false); }}
                >
                    Eliminar
                </Button>
            }
        />
    );
}
